import * as z from "../../../vendor/zod/src/index";
const InvalidCode = z.object({
    type: z.literal("InvalidCode"),
});
const Granted = z.object({
    type: z.literal("Granted"),
    token: z.string(),
});
export default z.union([InvalidCode, Granted]);
